import { ChainId } from "@bridgesplit/abf-sdk";

export const WORMHOLE_NFT_CONTRACTS = {
    [ChainId.Solana]: "WnFt12ZrnzZrFZkt2xsNsaNWoQribnuQ5B5FrDbwDhD",
    [ChainId.Ethereum]: "0x6FFd7EdE62328b3Af38FCD61461Bbfc52F5651fE",
    [ChainId.Polygon]: "0x90BBd86a6Fe93D3bc3ed6335935447E75fAb7fCf"
};
